import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 32px;
  text-align: center;
  color: ${({ theme }) => theme.colors?.text?.body ?? "#6b7280"};
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.text?.heading ?? "#111827"};
  margin-bottom: 8px;
`;

const Description = styled.p`
  margin: 0;
  font-size: 14px;
  max-width: 360px;
`;

/**
 * Consistent empty state for lists/tables.
 * @param {string} [title] - Short title (e.g. "No users yet")
 * @param {string} [description] - Optional description
 */
export function EmptyState({ title = "No data yet", description }) {
  return (
    <Wrapper>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
    </Wrapper>
  );
}
